import axios from 'axios'
import _ from 'lodash';
import router from '../router';
import { Message } from 'element-ui';
import md5 from 'js-md5';

var REQ_URL;   //API地址 
var UPLOAD_URL;//上传文件地址
var PATH_URL;//上传文件地址
var OCR_URL;//OCR地址
var Organization_Code;

if(process.env.VUE_APP_PREAPI == 'product'){
//生产环境 
	REQ_URL = "https://api.ygj.wondpay.com/";   //API地址
	UPLOAD_URL = 'https://file.ygj.wondpay.com/file_upload';//上传文件地址
	PATH_URL = 'https://api.ygj.wondpay.com/file_path';//上传文件地址
	OCR_URL = 'https://file.ygj.wondpay.com/';//OCR地址
    Organization_Code = location.hostname.split('.')[0]
}else if(process.env.VUE_APP_PREAPI == 'test'){
//测试环境 
	REQ_URL = "https://xapi.wondpay.com/";   //测试地址
	UPLOAD_URL = 'https://xfile.wondpay.com/file_upload';//测试上传文件地址
	PATH_URL = 'https://xapi.wondpay.com/file_path';//测试上传文件地址
	OCR_URL = 'https://xfile.wondpay.com/';//测试OCR地址
    Organization_Code = location.hostname.split('.')[0]
}else{
	//本地环境(无php本地 修改为测试环境api) 
	REQ_URL = "http://api.ys.cn/";   //测试地址
	UPLOAD_URL = 'http://file.ys.cn/file_upload';//测试上传文件地址
	PATH_URL = 'http://api.ys.cn/file_path';//测试上传文件地址
	OCR_URL = 'http://file.ys.cn/';//测试OCR地址
    Organization_Code = 'xweb'
 // REQ_URL = "https://ysapi.rkgoc.cn/";   //API地址
 // UPLOAD_URL = 'https://ysfile.rkgoc.cn/file_upload';//上传文件地址
 // PATH_URL = 'https://ysapi.rkgoc.cn/file_path';//上传文件地址
 // OCR_URL = 'https://ysfile.rkgoc.cn/';//OCR地址
 // Organization_Code = 'ysadmin'
}
/********************************************************************************/

const TIME_OUT_MS = 60 * 1000 // 默认请求超时时间
const BASE_URL  = REQ_URL;

/*
 * @param response 返回数据列表
 */
function handleResults(resolve) {
	var result = resolve.data
	if (result.code == 500000) { //token失效后退出
		Message.error(result.msg);
		router.push({ path: '/login' })
	}
	// switch (result.code) {
	// 	case 0:

	// 		break
	// 	default:
	// 		result = {
	// 			code: result.code
	// 		}
	// 		Toast('系统报错了')
	// 		break
	// }
	return result
}

function handleUrl(url) {
	url = BASE_URL + url
	// BASE_URL是接口的ip前缀，比如http:10.100.1.1:8989/
	return url
}

/*
 * @param data 参数列表
 * @return
 */
function handleParams(data) {
	let key = "key=baGxm8";
	let sorts = []; //排序数组
	if (!_.isEmpty(data)) { //如果data为空不进入
		_.forEach(data, (v, k) => {
			if (_.isPlainObject(v) && _.isEmpty(v)) {
				v = '';  // 空对象转为空字符串
			}
			sorts.push(`${k}=${v}`)
		})
	}

	let concatArr = sorts.sort(); //排序
	concatArr.push(key); //key始终在最后
	_.remove(concatArr, (v) => {
		// return v == sign; //这个移除有错误 添加下面这一行
		return v.split("=")[0] == "sign"
	});
	let reqArr = concatArr.join('&').toLowerCase(); //&连接
	let sign = md5(reqArr); //加密
	console.log(reqArr)
	data.sign = sign;
	return data
}


export default {
	uploadUrl: UPLOAD_URL,//上传文件
	pathUrl: PATH_URL,//保存本地
	reqUrl: REQ_URL,//请求
	/*
	 * @param url
	 * @param data
	 * @param response 请求成功时的回调函数
	 * @param exception 异常的回调函数
	 */
	post(url, data, response, exception) {
		axios({
			method: 'post',
			url: handleUrl(url),
			// url: url,
			data: handleParams(data),
			timeout: TIME_OUT_MS,
			headers: {
				'Content-Type': 'application/json; charset=UTF-8',
				// "Organization-Code": location.hostname.split('.')[0],
				"Organization-Code": Organization_Code,
				'Authorization': 'Bearer' + sessionStorage.getItem('token'),
				'Iden': sessionStorage.getItem('admin_id')+"|"+sessionStorage.getItem('username')+"|"+sessionStorage.getItem('level'),
			}
		}).then(
			(result) => {
				response(handleResults(result))
			}
		).catch(
			(error) => {
				if (exception) {
					exception(error)
				} else {
					// console.log(error)
				}
			}
		)
	},
	/*
	 * get 请求
	 * @param url
	 * @param response 请求成功时的回调函数
	 * @param exception 异常的回调函数
	 */
	get(url, response, exception) {
		axios({
			method: 'get',
			url: handleUrl(url),
			timeout: TIME_OUT_MS,
			headers: {
				'Content-Type': 'application/json; charset=UTF-8',
				"Organization-Code": location.hostname.split('.')[0],
				'Authorization:': 'Bearer' + sessionStorage.getItem('token'),
				'Iden': sessionStorage.getItem('admin_id')+"|"+sessionStorage.getItem('username')+"|"+sessionStorage.getItem('level'),
			}
		}).then(
			(result) => {
				response(handleResults(result))
			}
		).catch(
			(error) => {
				if (exception) {
					exception(error)
				} else {
					// console.log(error)
				}
			}
		)
	},
	/*
	 * 导入文件
	 * @param url
	 * @param data
	 * @param response 请求成功时的回调函数
	 * @param exception 异常的回调函数
	 */
	uploadFile(url, data, response, exception) {
		axios({
			method: 'post',
			url: handleUrl(url),
			data: handleParams(data),
			dataType: 'json',
			processData: false,
			contentType: false
		}).then(
			(result) => {
				response(handleResults(result, data))
			}
		).catch(
			(error) => {
				if (exception) {
					exception(error)
				} else {
					// console.log(error)
				}
			}
		)
	},
	/*
	 * 下载文件用，导出 Excel 表格可以用这个方法
	 * @param url
	 * @param param
	 * @param fileName 如果是导出 Excel 表格文件名后缀最好用.xls 而不是.xlsx，否则文件可能会因为格式错误导致无法打开
	 * @param exception 异常的回调函数
	 */
	downloadFile(url, data, fileName, exception) {
		axios({
			method: 'post',
			url: handleUrl(url),
			data: handleParams(data),
			responseType: 'blob'
		}).then(
			(result) => {
				const excelBlob = result.data
				if ('msSaveOrOpenBlob' in navigator) {
					// Microsoft Edge and Microsoft Internet Explorer 10-11
					window.navigator.msSaveOrOpenBlob(excelBlob, fileName)
				} else {
					const elink = document.createElement('a')
					elink.download = fileName
					elink.style.display = 'none'
					const blob = new Blob([excelBlob])
					elink.href = URL.createObjectURL(blob)
					document.body.appendChild(elink)
					elink.click()
					document.body.removeChild(elink)
				}
			}
		).catch(
			(error) => {
				if (exception) {
					exception(error)
				} else {
					// console.log(error)
				}
			}
		)
	},
	uploadFileFormData(url, data, response, exception) {
		axios({
			method: 'post',
			url: handleUrl(url),
			data: data,
			timeout: TIME_OUT_MS,
			headers: {
				'Content-Type': 'multipart/form-data',
				"Organization-Code": 'st',
				'Authorization': 'Bearer' + sessionStorage.getItem('token'),
				'Iden': sessionStorage.getItem('admin_id')+"|"+sessionStorage.getItem('username')+"|"+sessionStorage.getItem('level')
			}
		}).then(
			(result) => {
				response(handleResults(result))
			}
		).catch(
			(error) => {
				if (exception) {
					exception(error)
				} else {
					// console.log(error)
				}
			}
		)
	},
	EditorFile(url, data, response, exception) {
		axios({
			method: 'post',
			url: url,
			data: data,
			timeout: TIME_OUT_MS,
			headers: {
				'Content-Type': 'multipart/form-data',
				'Authorization': 'Bearer' + sessionStorage.getItem('token'),
				'Iden': sessionStorage.getItem('admin_id')+"|"+sessionStorage.getItem('username')+"|"+sessionStorage.getItem('level')
			}
		}).then(
			(result) => {
				response(handleResults(result))
			}
		).catch(
			(error) => {
				if (exception) {
					exception(error)
				} else {
					// console.log(error)
				}
			}
		)
	},
	TinymceUploadFile(url, data, response, exception) {
		axios({
			method: 'post',
			url: url,
			data: data,
			timeout: TIME_OUT_MS,
			headers: {
				'Content-Type': 'multipart/form-data',
				'Authorization': 'Bearer' + sessionStorage.getItem('token'),
			}
		}).then(
			(result) => {
				response(handleResults(result))
			}
		).catch(
			(error) => {
				if (exception) {
					exception(error)
				} else {
					// console.log(error)
				}
			}
		)
	},
		/*
	 * @param url
	 * @param data
	 * @param response 请求成功时的回调函数
	 * @param exception 异常的回调函数
	 */
	OCR_POST(url, data, response, exception) {
			axios({
				method: 'post',
				url: OCR_URL+url,
				data: handleParams(data),
				timeout: TIME_OUT_MS,
				headers: {
					'Content-Type': 'application/json; charset=UTF-8',
					"Organization-Code": location.hostname.split('.')[0],
					'Authorization': 'Bearer' + sessionStorage.getItem('token'),
					'Iden': sessionStorage.getItem('admin_id')+"|"+sessionStorage.getItem('username')+"|"+sessionStorage.getItem('level'),
				}
			}).then(
				(result) => {
					response(handleResults(result))
				}
			).catch(
				(error) => {
					if (exception) {
						exception(error)
					} else {
						// console.log(error)
					}
				}
			)
		},
}
